import { useState, useEffect, useCallback } from 'react';
import { useWorkspace } from '@mssgme/hooks';
import escapeStringRegexp from 'escape-string-regexp';

import { useEventEmitter } from '@mssgme/ui';

export default function useQuickRepliesMatch() {
    const workspace = useWorkspace();
    const [isOpen, setIsOpen] = useState();
    const [value, setValue] = useState('');
    const ee = useEventEmitter();

    useEffect(() => {
        ee.on('inbox:messageChange', setValue);
        return () => ee.removeListener('inbox:messageChange', setValue);
    }, []);

    let items = [];

    if (value) {
        const reg = new RegExp(`^${escapeStringRegexp(value)}`, 'i');
        items = workspace.replies.filter(({ shortcut }) => reg.test(shortcut));
    }

    useEffect(() => {
        setIsOpen(items.length > 0);
    }, [items.length]);

    const onSelectItem = useCallback(({ message }) => {
        ee.emit('inbox:replySelect', message);
    }, []);

    return {
        isOpen,
        items,
        onSelectItem,
    };
}
